import { sortCommentsAscending } from "components/common/comments/sortComments";
import { cloneDeep } from "lodash";
import { applyPatch } from "rfc6902";
import { checkChanged } from "./checkChanged";
import { ITlfActionPatchTlfComments, PATCH_TLF_COMMENTS, TlfContextProps } from "./interface";

/**
 * Applies a JSON patch to the current TLF comments collection.
 *
 * @param state - Current TLF context state.
 * @param action - Comment-patch action containing the RFC6902 operations.
 * @returns Updated state with patched comments when a patch is supplied.
 */
export const tlf_patchTlfComments = (
  state: TlfContextProps,
  action: ITlfActionPatchTlfComments,
): TlfContextProps => {
  const newState = { ...state };

  if (!newState.tlfData) {
    throw new Error(
      `tlfContextReducer: ${PATCH_TLF_COMMENTS}:${action.calledFrom}: TLF data not set`,
    );
  }

  const commentsPatch = action.patch;
  /* istanbul ignore else -- empty patches intentionally leave the current comment state unchanged. */
  if (commentsPatch && commentsPatch.length > 0) {
    const newComments = cloneDeep(newState.tlfData.comments).sort(sortCommentsAscending);
    applyPatch(newComments, commentsPatch);
    newState.tlfData = {
      ...newState.tlfData,
      comments: newComments,
    };
    newState.forcePushToParent = true;
    checkChanged(newState);
  }

  return newState;
};
